import React, { FC } from 'react';

import { InvestmentPackage, Money as MoneyModel, resolveInvestmentPackageStatus } from 'api-client';
import { Money } from 'components';
import { CapitalProtectionBadge, PackageStatusBadge } from 'components/common/StatusBadge';

import { formatEntryDate, formatPackageNumber } from '../shared/packageUtils';
import styles from './PackageDetails.module.scss';

type Props = {
  pkg: InvestmentPackage;
};

export const PackageDetailsHeader: FC<Props> = ({ pkg }) => {
  const status = resolveInvestmentPackageStatus(pkg);

  return (
    <div className={styles.headerRow}>
      <div className={styles.headerMainCard}>
        <div className={styles.headerPattern} aria-hidden="true" />
        <div className={styles.headerMainContent}>
          <div className={styles.headerTitleRow}>
            <h1 className={styles.headerTitle}>Пакет #{formatPackageNumber(pkg.uuid)}</h1>
            <div className={styles.headerBadges}>
              <PackageStatusBadge status={status} />
              {pkg.enableCapitalProtection ? <CapitalProtectionBadge /> : null}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.headerInfoCard}>
        <div className={styles.headerInfoRow}>
          <span className={styles.headerInfoLabel}>Дата формирования пакета</span>
          <span className={styles.headerInfoValue}>{formatEntryDate(pkg.createdAt)}</span>
        </div>
        <div className={styles.headerInfoRow}>
          <span className={styles.headerInfoLabel}>Забронировано в пакет</span>
          <span className={styles.headerInfoValue}>
            <Money money={pkg.money} />
          </span>
        </div>
        <div className={styles.headerInfoRow}>
          <span className={styles.headerInfoLabel}>Аванс комиссии</span>
          <span className={styles.headerInfoValue}>
            <Money money={pkg.advanceCommission} />
          </span>
        </div>
        <div className={styles.headerInfoRow}>
          <span className={styles.headerInfoLabel}>Выведено на основной счет</span>
          <span className={styles.headerInfoValue}>
            <Money money={pkg.withdrawnToMain} />
          </span>
        </div>
      </div>
    </div>
  );
};
